// Protect the original when its source glyphs will first be removed. Once
// those glyphs have been removed in a saved copy, reopening that copy must
// preserve ordinary Save behavior; the replacement remains editable.
export function hasDestructiveTextEdits(edits) {
  return (edits || []).some(
    (e) => e && e.source === 'detected' && !e.sourceRemoved && (e.modified || e.deleted)
  );
}

export function suggestCopyName(fileName) {
  const name = fileName || 'document.pdf';
  const dot = name.lastIndexOf('.');
  const base = dot > 0 ? name.slice(0, dot) : name;
  const ext = dot > 0 ? name.slice(dot) : '.pdf';
  if (base.endsWith(' (edited)')) return `${base}${ext}`;
  return `${base} (edited)${ext}`;
}
